import { HomeWork, SvgIconComponent } from '@mui/icons-material';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

interface IconTitleProps {
  title: string;
  IconComponent?: SvgIconComponent;
}

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
    color: palette.neutral[100],
  },
}));

export const IconTitle = ({ title, IconComponent = HomeWork }: IconTitleProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.title}>
      <IconComponent sx={{ fontSize: '20px' }} />
      {title}
    </div>
  );
};

export default IconTitle;
